import { IconButton } from '@mui/material';
// Direct paths, not the `src/components` barrel: this file is pulled in by the pane-header
// layout blocks that the barrel itself re-exports, so the barrel would close an import cycle.
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { paneHeaderIconButtonSx } from 'src/components/Navbar/navbar.styles';
import { Tooltip } from 'src/components/Tooltip/Tooltip';
import { useGlobalStore } from 'src/store';

export const MobileNavMenuButton = () => {
  const navbar = useGlobalStore.use.navbar();
  const setNavbar = useGlobalStore.use.setNavbar();

  return (
    <Tooltip title="App menu">
      <IconButton
        disableRipple
        sx={paneHeaderIconButtonSx}
        onClick={() => setNavbar({ isOpen: !navbar.isOpen })}
        data-testid="mobile-nav-menu-button"
      >
        <DynamicIcon name="menu" />
      </IconButton>
    </Tooltip>
  );
};
